import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { UserConfigurationService } from "../../services/user-configuration.service";
import { Store } from "@ngrx/store";
import { map } from "rxjs/operators";

@Component({
	selector: "user-dashboard-links",
	templateUrl: "./dashboard-links.component.html",
	styleUrls: [ "./dashboard-links.component.scss" ]
})
export class DashboardLinksComponent implements AfterViewInit {
	links: any[];
	links$: Observable<any[]>;
	constructor(private userConfigurationService: UserConfigurationService, private store: Store<any>) {
		this.links$ = this.userConfigurationService.config$.pipe(map(data => data.dashboardLinks));
		this.links = [
			{
				title: "ÙØ´Ø§ÙØ¯Ù Ø­Ø³Ø§Ø¨ Ú©Ø§Ø±Ø¨Ø±Û",
				route: "/user/panel/profile",
				// description: "ÙÙØ±Ù Ø§ÛÙ¾Ø³ÙÙ ÙØªÙ Ø³Ø§Ø®ØªÚ¯Û Ø¨Ø§ ØªÙÙÛØ¯ Ø³Ø§Ø¯Ú¯Û ÙØ§ÙÙÙÙÙ",
				icon: "person"
			}
			// ,
			// {
			// 	route: "/user/panel/password/change",
			// 	title: "ØªØºÛÛØ± Ú©ÙÙÙ Ø¹Ø¨ÙØ±",
			// 	// description: "ÙÙØ±Ù Ø§ÛÙ¾Ø³ÙÙ ÙØªÙ Ø³Ø§Ø®ØªÚ¯Û Ø¨Ø§ ØªÙÙÛØ¯ Ø³Ø§Ø¯Ú¯Û ÙØ§ÙÙÙÙÙ",
			// 	icon: "security"
			// }
		];
	}

	ngAfterViewInit() {}
}
